import {paRoute} from './paRoute';
import {paNumber} from './helpers/paNumber';
import {paString} from './helpers/paString';
import {paDom, get} from "./paDom";

export const paTpl = {
    /**
     * usage:
     * paTpl.preloadImages(['paRoute.imageUrl(1.png'), paRoute.imageUrl(2.png')])
     *
     * @param imageSrcArray
     */
    preloadImages(imageSrcArray) {
        let rowLength = imageSrcArray.length;
        for (let img = 1; img < rowLength; img++) {
            let imgToAppend = document.createElement('img');
            imgToAppend.src = imageSrcArray[img];
            imgToAppend.setAttribute('lazyload', 'lazyload');
            get('#pa-engine-image-preload').appendChild(imgToAppend);
        }
    },
    // prepare data for rendering
    getRenderedValue(fieldId, value) {
        if (typeof value.trim == 'function') {
            value = value.trim();
        }
        return value;
    },
    fillPlaceholders(data) {
        for (let field in data) {

            let preparedValue = this.getRenderedValue(field, data[field]),
                places = get('[data-place="' + field + '"]');

            if (paDom.isElement(places)) {
                places = [places];
            }

            for (let i = 0; i < places.length; i++) {
                places[i].innerHTML = preparedValue;
            }
        }
    },
    /**
     * template is:
     * <div data-iframe-target-id="AnzahlWeihnachtskarten2" class="pae-embed-code"></div>
     * where data-iframe-target-id is id of element that is gonna be inside iframe
     */
    renderEmbedCode(){
        get('.pae-embed-code').forEach(function(el, i){
            let iframeTargetId = el.dataset.iframeTargetId;
            el.appendChild(paDom.c(paTpl.getEmbedCode(iframeTargetId)));
        });
    },
    getEmbedCode(iframeTargetId) {
        iframeTargetId = iframeTargetId || 'all';
        let urlParams = {
                i: paNumber.random(0, 9999),
                iframeTargetId: iframeTargetId
            },
            code = '<script data-id="' + iframeTargetId + '" src="' + paRoute.base + 'paEngineIframeLoader.js?' + paRoute.urlify(urlParams) + '" defer></script>',
            escapedCode = paString.htmlEntities(code),
            textarea = '<textarea readonly onClick="this.select();">' + escapedCode + '<p>L’étude complète est disponible sur le site de <a href="https://www.faireparterie.fr/influence-de-la-pop-culture-sur-les-prenoms" target="_blank">Faireparterie</a>.</p></textarea>';

        return textarea;
    },
    get(tplId, data) {
        let $tpl = get(tplId),
            tplHtml = $tpl.innerHTML;

        for (let field in data) {
            let regex = new RegExp('{' + field + '}', 'g');
            tplHtml = tplHtml.replace(regex, data[field]);
        }
        return paDom.create(tplHtml);
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/paTpl.js